import type { ThemeV3 } from '../types/themeTypes';

/** A dark theme built from the classic Gruvbox palette. */
export const macroGruvboxTheme = {
  id: 'Macro-Gruvbox',
  name: 'Macro-Gruvbox',
  version: 3,
  mode: 'dark',
  colorTokens: {
    'surface-0': '#282828',
    'surface-1': '#32302f',
    'surface-2': '#3c3836',
    'surface-3': '#504945',
    'surface-4': '#665c54',
    'content-0': '#fbf1c7',
    'content-1': '#ebdbb2',
    'content-2': '#d5c4a1',
    'content-3': '#bdae93',
    'content-4': '#a89984',
    edge: '#504945',
    'edge-muted': '#3c3836',
    accent: '#689d6a',
    red: '#fb4934',
    orange: '#fe8019',
    amber: '#d79921',
    yellow: '#fabd2f',
    lime: '#b8bb26',
    green: '#98971a',
    teal: '#689d6a',
    cyan: '#8ec07c',
    blue: '#83a598',
    violet: '#d3869b',
    purple: '#b16286',
    pink: '#d3869b',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': '#8ec07c',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-amber)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-0) 85%, var(--color-content-0))',
  },
} satisfies ThemeV3;
